/* Main routes */
export const ROUTE_MAIN = '/';

/* Auth routes */
export const ROUTE_AUTH = '/auth';
export const ROUTE_LOGIN = `${ROUTE_AUTH}/login`;
export const ROUTE_REGISTER = `${ROUTE_AUTH}/register`;
export const ROUTE_BLOCKED = `${ROUTE_AUTH}/blocked`;
export const ROUTE_NOT_VERIFIED = `${ROUTE_AUTH}/not-verified`;

/* Verification routes */
export const ROUTE_EMAIL_VERIFICATION = '/email-verification';

/* Admin common routes */
export const ROUTE_ADMIN = '/admin';
export const ROUTE_ADMIN_MAIN = '/admin/main';
export const ROUTE_ADMIN_PROFILE = '/admin/profile';
export const ROUTE_ADMIN_CATALOGS = '/admin/catalogs';
export const ROUTE_ADMIN_APPEALS = '/admin/appeals';

/* Admin routes */
export const ROUTE_ADMIN_ORGANIZATIONS = '/admin/organizations';
export const ROUTE_ADMIN_USERS = '/admin/users';
export const ROUTE_ADMIN_PRODUCT_BASE = '/admin/product';
export const ROUTE_ADMIN_ORDERS = '/admin/orders';
export const ROUTE_ADMIN_FILES = '/admin/files';

/* Manager routes */
export const ROUTE_ADMIN_APPROVE = '/admin/approve';
export const ROUTE_ADMIN_PRODUCT_BUY_ORDER_BASE = '/admin/buy-order';

/* Manager/employee routes */
export const ROUTE_ADMIN_APPROVE_ORDERS = '/admin/approve#orders';
export const ROUTE_ADMIN_APPROVE_REQUESTS = '/admin/approve#requests';
export const ROUTE_ADMIN_CATALOG = '/admin/catalog';
export const ROUTE_ADMIN_EMPLOYEES = '/admin/employees';
export const ROUTE_ADMIN_PRODUCT_CREATE_ORDER_BASE = '/admin/create-order';
export const ROUTE_ADMIN_CATALOG_COMPLETED = '/admin/catalog?tab=completed';
